const externalWebView = () => {
  let isExternamWebView = false;

  const standalone = window.navigator.standalone;
  const userAgent = window.navigator.userAgent.toLowerCase();
  const safari = /safari/.test(userAgent);
  const ios = /iphone|ipod|ipad/.test(userAgent);

  if (ios) {
    if (!standalone && safari) {
      isExternamWebView = false;
    } else if (!standalone && !safari) {
      isExternamWebView = true;
    }
  } else {
    if (userAgent.includes('wv')) {
      isExternamWebView = true;
    } else {
      isExternamWebView = false;
    }
  }

  return isExternamWebView;
};

export default externalWebView;
